<template>
    <div class="text-block block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/conversation.png" alt="">
                        </div>

                        <h4>Suggestion</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <label>Text</label>
<!--                    <v-textarea-->
<!--                            v-model="data.text"-->
<!--                            :error="!data.text"-->
<!--                            :error-messages="!data.text? 'Text is Required':''"-->
<!--                            outline-->
<!--                    >-->
<!--                    </v-textarea>-->
                    <vTextareaAutocomplete v-model="data.text" :type="'textarea'"
                                           :validationRules="autocompleteSuggestedValidationRules"></vTextareaAutocomplete>
                    <buttons-list :buttons="data.buttons" :blocks-list="blocksList" ></buttons-list>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import buttonsList from './common-inner-blocks/button-list-blocks'
    export default {
        name: "text-block",
        components: {
            buttonsList
        },
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                autocompleteSuggestedValidationRules: [
                    v => !!v || 'Text is Required'
                ]
            }
        },
        mounted() {
            if (!this.data.buttons) {
                this.data.buttons = []
            }
        },
        methods: {

        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style scoped>

</style>